import { routeContext } from '@/context/routes/context';
import { RoutesActionTypes } from '@/context/routes/reducer';
import { routesService } from '@/services/routes';
import { Route } from '@/services/routes/route.vm';
import { useCallback, useContext, useMemo } from 'react';

const useLearningRoutes = () => {
  const { routes, dispatch, handleReload, loading } = useContext(routeContext);

  const routesList = useMemo(() => {
    const routeList = Object.values(routes);
    const orderedRoutesList = [...routeList].sort((a, b) => {
      return a.order - b.order;
    });
    return orderedRoutesList;
  }, [routes]);

  const loadRoutes = useCallback(
    (routes?: Route[]) => {
      if (routes) {
        dispatch<Route[]>({
          type: RoutesActionTypes.LOAD_ROUTES,
          payload: routes,
        });
        return;
      }
      routesService
        .getRoutes()
        .then((routes) => {
          dispatch<Route[]>({
            type: RoutesActionTypes.LOAD_ROUTES,
            payload: routes,
          });
        })
        .catch((error) => {
          console.error('Error fetching routes:', error);
        });
    },
    [dispatch],
  );

  const getRouteById = useCallback(
    (id: string) => {
      const route = routes[id];
      return route;
    },
    [routes],
  );

  const addOrReplaceRoute = useCallback(
    (route: Route) => {
      dispatch({
        type: RoutesActionTypes.ADD_OR_REPLACE_ROUTE,
        payload: route,
      });
    },
    [dispatch],
  );

  const updateRoute = useCallback(
    (id: string, route: Partial<Route>) => {
      dispatch({
        type: RoutesActionTypes.UPDATE_ROUTE,
        payload: { id, route },
      });
    },
    [dispatch],
  );

  const deleteRoute = useCallback(
    (id: Route['id']) => {
      dispatch({
        type: RoutesActionTypes.DELETE_ROUTE,
        payload: id,
      });
    },
    [dispatch],
  );

  return {
    routes,
    routesList,
    loadRoutes,
    updateRoute,
    deleteRoute,
    getRouteById,
    addOrReplaceRoute,
    handleReloadRoutes: handleReload,
    loadingRoutes: loading,
  };
};

export default useLearningRoutes;